
import { Component, input } from '@angular/core';
import { RaSquareIconComponent } from 'src/app/shared/components/ra-square-icon/ra-square-icon.component';
import { RaIconComponent } from 'src/app/shared/components/ra-icon/ra-icon.component';
import { RaTooltipDirective } from 'src/app/shared/directives';

@Component({
    selector: 'ia-item',
    templateUrl: 'ia-item.component.html',
    styleUrl: 'ia-item.component.scss',
    imports: [RaSquareIconComponent, RaTooltipDirective, RaIconComponent],
})
export class IaItemComponent {
    public icon = input<string>('');
    public text = input<string>('');
    public disabled = input<boolean>(false);
    public tooltip = input<string>('');
}
